export const FLAGS = {
  DATA_MANAGER: 'data-manager',
  ALWAYS_REFRESH_DASHLET: 'always-refresh-dashlet',
};
